<template>
  <div>
    <div class="navigator-bar">
      {{ this.form.id ? '编辑角色' : '添加角色' }}
      <el-button @click="$router.back()" size="small">返回</el-button>
    </div>

    <div class="container">
      <el-form :rules="rules" :model="form" label-position="right" ref="form" label-width="80px">
        <el-form-item label="角色名">
          <el-input style="width: 240px;" v-model="form.name" placeholder="请输入角色名"></el-input>
        </el-form-item>

        <el-form-item class="role_edit-permissions" label="选择角色">
          <el-checkbox style="color: #ccc;" :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group class="role_edit-checkbox" v-model="form.cansList" @change="handlecheckedPermissionsChange">
            <el-checkbox v-for="can in cansList" :label="can" :key="can">{{ can }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
      </el-form>
    </div>

    <div style="text-align: right;padding: 24px;">
      <el-button v-if="!form.id" @click="create" size="small" type="primary">添加</el-button>
      <el-button v-if="form.id" @click="update" size="small" type="primary">更新</el-button>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Tab from '../../components/tab/index.vue';
import { M } from '../../service/grpc.js';
import { rpc } from '../../service/index.js';
import { getToken } from '../../service/helper.js';
import { getCachedStore } from '../../router/auth.js';

export default {
  name: 'EmployeeEdit',
  data() {
    return {
      token: '',
      form: {
        id: 0,
        name: '',
        cansList: []
      },
      rules: {
        name: [{ required: true, message: '请输入角色名', trigger: 'blur' }],
        cansList: [{ type: 'array', required: true, message: '请选择权限', trigger: 'change' }]
      },
      checkAll: false,
      isIndeterminate: false,
      cansList: []
    };
  },
  async mounted() {
    this.token = getToken();
      var kind = (await getCachedStore()).kind;
      if(kind == 0){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 1){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 2){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "名师名生管理",
              "配送费管理",
              "预约管理",
              "报名管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 3){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 4){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "周期购管理",
              "配送费管理",
              "轮播图管理",
              "小程序码管理",
              "打印机管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 6){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "轮播图管理",
              "打印机管理",
              "小程序码管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
      if(kind == 7){
          this.cansList = [
              "订单管理",
              "商品管理",
              "数据分析", //
              "优惠券管理",
              "营销规则管理",
              "会员储值管理",
              "用户管理", //
              "小程序模版管理",
              "管理员管理",
              "店铺信息管理",
              "配送费管理",
              "打印机管理",
              "小程序码管理",
              "轮播图管理",
              "分销设置",
              "分店管理",
              "红包管理",
          ];
      }
    if (this.$route.query.id) {
      rpc('StoreStoreRoleService.GetStoreRole', M('IDWithTokenRequest', { token: M('Token', { token: this.token }), id: this.$route.query.id })).then(res => {
        res.cansList = res.cansList.filter(v => this.cansList.includes(v));
        this.form = res;
      });
    }
  },
  methods: {
    create() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await rpc('StoreStoreRoleService.CreateStoreRole', M('StoreRoleWithTokenRequest', { token: M('Token', { token: this.token }), storerole: M('StoreRole', this.form) }));
          this.$router.back();
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }
      });
    },
    update() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          const res = await rpc('StoreStoreRoleService.UpdateStoreRole', M('StoreRoleWithTokenRequest', { token: M('Token', { token: this.token }), storerole: M('StoreRole', this.form) }));
          this.$router.back();
          this.$message({
            message: '保存成功',
            type: 'success'
          });
        }
      });
    },
    handleCheckAllChange(val) {
      this.form.cansList = this.checkAll ? this.cansList : [];
      this.isIndeterminate = false;
    },
    handlecheckedPermissionsChange(val) {
      this.checkAll = val.length === this.cansList.length;
      this.isIndeterminate = val.length === this.cansList.length || val.length === 0 ? false : true;
    }
  }
};
</script>

<style scoped>
.navigator-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  color: #999;
  margin-top: 18px;
}
</style>
<style>
.role_edit-checkbox {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-gap: 12px;
}
.role_edit-checkbox .el-checkbox + .el-checkbox {
  margin: 0;
}
.role_edit-checkbox .el-checkbox__input {
  display: none !important;
}
.role_edit-checkbox .el-checkbox__label {
  color: #666;
  padding: 0 12px;
  line-height: 2.225;
  border: 1px solid;
  border-radius: 4px;
  font-weight: 300;
  display: block;
  text-align: center;
}
.role_edit-permissions .el-form-item__error {
  margin-top: 12px;
}
</style>
